import React from 'react';
import {
	Box,
	Theme,
	Select,
	Input,
	Badge,
	SelectChangeEvent,
	MenuItem,
	Checkbox,
	ListItemText,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export interface Props {
	name: string;
	value: string[];
	onChange: (event: SelectChangeEvent<any>) => void;
	options: { id: string; text: string }[];
}
const InventorySearchBarSelect = (props: Props) => {
	const { name, value, onChange, options } = props;
	const classes = useStyles();
	return (
		<Box className={classes.barSection}>
			<Select
				fullWidth
				multiple
				displayEmpty
				value={value}
				onChange={onChange}
				input={<Input sx={{ px: 2 }} />}
				renderValue={(selected) => {
					const count = (selected as string[]).length;
					return (
						<Box>
							<Badge
								classes={{
									root: classes.badgeRoot,
									badge: classes.badgeBadge,
									invisible: classes.badgeInvisible,
								}}
								color="primary"
								invisible={count === 0}
								badgeContent={count}
							>
								<span>{name}</span>
							</Badge>
						</Box>
					);
				}}
				sx={{ minWidth: 110, px: 2 }}
				disableUnderline={true}
			>
				{options.map((option) => (
					<MenuItem key={option.id} value={option.id}>
						<Checkbox checked={value.includes(option.id)} />
						<ListItemText primary={option.text} />
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		barSection: {
			borderLeft: `1px solid ${theme.palette.border.inputOutline}`,
			display: 'flex',
			alignItems: 'center',
			overflow: 'hidden',
			flex: '0 1 auto',
			height: 40,
			[theme.breakpoints.down('md')]: {
				flex: 1,
				'&:first-child': {
					borderLeft: 'none',
				},
			},
			[theme.breakpoints.down('sm')]: {
				borderLeft: 'none',
			},
		},
		badgeRoot: {
			height: '100%',
			verticalAlign: 'text-top',
		},
		badgeBadge: {
			position: 'relative',
			top: '12px',
			left: '-5px',
			color: theme.palette.text.secondary,
			backgroundColor: 'transparent',
			border: `1px ${theme.palette.text.secondary} solid`,
		},
		badgeInvisible: {
			display: 'none',
		},
	}),
);

export default InventorySearchBarSelect;
